@if (configured) {
  <router-outlet />
} @else {
  <main class="service-message" role="status">
    <h1>Giving is temporarily unavailable</h1>
    <p>Please try again later or contact the organization for assistance.</p>
  </main>
}
